import { canonicalFitnessExerciseName } from '@/lib/fitnessExerciseIdentity';

/** Presentation only: retained plan/log names remain the source of persistence identity.
 * The curated plans reuse one ambiguous literal for two explicit muscle contexts.
 * Never infer a variant from translated text or from a muscle alone.
 */
export function fitnessExercisePresentationName(name: string, muscle?: string): string {
  if (name === 'Dumbbell Press') {
    if (muscle === 'chest') return 'Flat Dumbbell Bench Press';
    if (muscle === 'shoulders') return 'Dumbbell Shoulder Press';
  }
  return canonicalFitnessExerciseName(name);
}

/** Media and labels may use a presentation name; the execution keeps its source
 * key except when a declared context is required to select the correct variant. */
export function fitnessExercisePresentationIdentity(name: string, muscle?: string): string {
  return name === 'Dumbbell Press' ? fitnessExercisePresentationName(name, muscle) : name;
}
